import { DatePicker, type DatePickerPropsInterface, Input } from '@zillow/constellation-10';
import { useState } from 'react';

export const BillingPortalDatePicker = (props: DatePickerPropsInterface) => {
  const [open, setOpen] = useState(false);

  return (
    <DatePicker
      open={open}
      onOpenChange={(open) => setOpen(open)}
      input={
        <Input
          css={{ paddingLeft: 'sm' }}
          placeholder={props.dateFormat}
          value={props.value?.toString() || ''}
          size={props.size}
          readOnly
          onClick={() => setOpen(true)}
          onFocus={() => setOpen(true)}
        />
      }
      {...props}
    />
  );
};
